import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-inventory",
  "use": "icon-inventory-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-inventory\">\n    <path d=\"M512 605.376L0 302.656 512 0l512 302.656z\" />\n    <path d=\"M512 699.008L95.296 452.672 0 508.992l512 302.656 512-302.656-95.296-56.32z\" />\n    <path d=\"M512 911.36L95.296 664.96 0 721.28 512 1024l512-302.72-95.296-56.32z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/admin/icons/svg/inventory.svg
// module id = Ulwp
// module chunks = 8